const DEBUG = process.env.NODE_ENV !== 'production';

export { DEBUG };
